import { render, staticRenderFns } from "./ProjectAction.vue?vue&type=template&id=294eca6c"
import script from "./ProjectAction.vue?vue&type=script&lang=ts"
export * from "./ProjectAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('294eca6c')) {
      api.createRecord('294eca6c', component.options)
    } else {
      api.reload('294eca6c', component.options)
    }
    module.hot.accept("./ProjectAction.vue?vue&type=template&id=294eca6c", function () {
      api.rerender('294eca6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectAction.vue"
export default component.exports